import styles from './LoadingSkeleton.module.scss';

export function LoadingSkeleton() {
  return (
    <div className={styles.collectionsGrid}>
      {[1, 2].map((i) => (
        <div key={i} className={styles.collectionSkeleton} />
      ))}
    </div>
  );
}
